import actionCreatorFactory from 'typescript-fsa';
import { MyLoungeResponse } from '@shared/types/mylounge';
import { CampaignFilterTags } from '@client/components/mylounge/banner/constants';
import { CategoryTabIds } from '@shared/constants';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchingCampaigns = actionCreator.async<null, MyLoungeResponse, string>(
    'FETCH_CAMPAIGNS',
);

export const updateImagesLoaded = actionCreator<boolean>('UPDATE_IMAGES_LOADED');

export const updateCategoryTabId = actionCreator<CategoryTabIds>('UPDATE_CATEGORY_ID');

export const updateFilterTags = actionCreator<CampaignFilterTags>('UPDATE_FILTER_TAGS');
